import Image from 'next/image'

export default function BlogImage ({ src = '', alt = '', title = '' }) {
    return (
        <Image
            src={src}
            alt={alt}
            title={title || alt}
            layout="fill"
            objectFit="cover" />
    )
}